import {fetchRemoteResult} from '@core/Api/api-util';
import ApiBase from "@core/Api/api-base";
import { controllerEndpoint } from "@modules/JourneyBuilder/api";

/**
 * Get sankey data for the given journey using the given endpoint as base endpoint
 * 
 * @param {String} [journeyId]
 * @param {JourneyReportStatisticsParameters} [requestParameters] 
 * @return {Promise<{ types: SankeyType[], data: SankeyNode[] }>}
 */
const getJourneyDataFromEndpoint = (journeyId, requestParameters) => {
    let endpoint = `${controllerEndpoint}GetSankeyData/`;
    
    //Create a copy we can modify without risking affecting our caller
    const queryParameters = { ...(requestParameters || {}) };
    
    //We assume our journeyId to be part of the route
    if(journeyId){
        endpoint += journeyId;
    }
    
    //Fully delete the property to ensure it's not included in our serialized parameters
    if(queryParameters.productNames && !queryParameters.productNames.length) delete queryParameters.productNames;

    const params = ApiBase.parameterize(queryParameters);
    
    if(params){
        if(endpoint.includes('?')){
            endpoint += '&';
        } else {
            endpoint += '?';
        }
        
        endpoint += params;
    }
    
    return getDataFromEndpoint(endpoint);
};

/**
 * Get sankey data from the given endpoint
 * 
 * @param {RequestInfo} endpoint
 * @return {Promise<{ types: SankeyType[], data: SankeyNode[] }>}
 */
const getDataFromEndpoint = async (endpoint) => {

    const errorMsg = 'Please make sure response from api contains two arrays named data and types.'

    const value = await fetchRemoteResult(endpoint);

    if(
        !value || 
        !Array.isArray(value.types) ||
        !Array.isArray(value.data)
    ){
        console.error(errorMsg);
        throw errorMsg;
    }
    
    return value;
    
    // return new Promise((resolve, reject) => {
    //     fetchRemoteResult(endpoint).then(
    //         (value) => {
    //             if(value && value.types && value.data) {
    //                 if(Array.isArray(value.types) && Array.isArray(value.data)) {
    //                     resolve({
    //                         types: value.types,
    //                         data: value.data
    //                     });
    //                 } else {
    //                     console.error(errorMsg);
    //                     reject(errorMsg);
    //                 }
    //             } else {
    //                 console.error(errorMsg);
    //                 reject(errorMsg);
    //             }
    //         },
    //         (error) => {
    //             console.error(error);
    //             reject(error);
    //         }
    //     );
    // });
};

export default {
    getJourneyDataFromEndpoint,
    getDataFromEndpoint
};